"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Typography_1 = require("@material-ui/core/Typography");
var Modal_1 = require("../Modal/Modal");
var core_1 = require("@material-ui/core");
var modalWithHeaderStyles_1 = require("./modalWithHeaderStyles");
var Close_1 = require("@material-ui/icons/Close");
var SectionLoader_1 = require("../Loader/SectionLoader");
var ModalWithHeader = react_1.memo(function (_a) {
    var children = _a.children, open = _a.open, toggleModal = _a.toggleModal, modalProps = _a.modalProps, titleProps = _a.titleProps, contentProps = _a.contentProps, title = _a.title, className = _a.className, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var modalStyles = modalWithHeaderStyles_1.default();
    if (loading) {
        return <SectionLoader_1.default />;
    }
    return (<Modal_1.default PaperProps={{ className: modalStyles.modalRoot }} labelledby="modal-title" open={open} toggleModal={toggleModal} hideCloseIcon={true} {...modalProps}>
        <core_1.DialogTitle className={modalStyles.closeContainer} disableTypography={true}>
          <Typography_1.default data-test="text:modal:title" align={'center'} className={modalStyles.title} variant="h4" {...titleProps}>
            {title}
          </Typography_1.default>
          <span className={modalStyles.closeButton} onClick={function () { return toggleModal(false); }}>
            <Close_1.default data-test="button:close" className={modalStyles.icon}/>
          </span>
        </core_1.DialogTitle>
        <core_1.DialogContent className={className} {...contentProps}>
          {children}
        </core_1.DialogContent>
      </Modal_1.default>);
});
exports.default = ModalWithHeader;
